import AtomContainer from "../lib/AtomContainer"
import IAtomModel from "../lib/IAtomModel";
import IBondModel from "../lib/IBondModel";

export const getSortedGraph = (atoms: IAtomModel[], container: AtomContainer) => {
    atoms.sort(function (a1,a2) {
        return container.getBondsAttachedTo(a2).length - container.getBondsAttachedTo(a1).length;
    });
    return atoms;
}

export const getSpanningTree = (graph: IAtomModel[], container: AtomContainer): Map<IAtomModel, Set<IAtomModel>> => {
    const spanningTree = new Map();

    graph.forEach((node) => {
        spanningTree.set(node, new Set());
    });

    const visitedAtoms = new Set();

    graph.forEach((node) => {
        container.getBondsAttachedTo(node).forEach((childB) => {
            const child = childB.getOtherAtom(node);
            if(!visitedAtoms.has(child)) {
                visitedAtoms.add(child);
                spanningTree.get(node).add(child);
                spanningTree.get(child).add(node);
            }
        });
    });
    return spanningTree;
}

export const getAllRings = (graph: IAtomModel[], spanningTree: Map<IAtomModel, Set<IAtomModel>>, container: AtomContainer, removeRings: boolean)=>  {
    const rings: IAtomModel[][] = [];
    const rejectedBonds: Set<IAtomModel[]> = getRejectedBonds(graph, spanningTree, container);
    rejectedBonds.forEach((bond) => {
        const start = bond[0];
        const end = bond[1];
        const ring = findRing(start, end, spanningTree);
        if(ring != undefined) {
            if(removeRings) { // get rid of rings
                for(const b of container.getBondsAttachedTo(start)) {
                    if(b.getOtherAtom(start) == end) {
                        container.bonds.splice(container.bonds.indexOf(b),1);
                    }
                }
                // ring.forEach(a => a.isInRing = false);
            }
            else {
                rings.push(ring);
            }
        }
        else {
            // @ts-ignore
            spanningTree.get(start).add(end);
            // @ts-ignore
            spanningTree.get(end).add(start);
        }
    });

    return rings;
}

export const getRejectedBonds = (graph: IAtomModel[], spanningTree: Map<IAtomModel, Set<IAtomModel>>, container: AtomContainer): Set<IAtomModel[]> => {
    const rejectedBonds: Set<IAtomModel[]> = new Set();
    const rejectedBondsString = new Set();

    graph.forEach((node) => {
        container.getBondsAttachedTo(node).forEach((childB) => {
            const child : IAtomModel = childB.getOtherAtom(node);
            // @ts-ignore
            if(!spanningTree.get(node).has(child)) {
                if(!rejectedBondsString.has(container.atoms.indexOf(child)+"-"+container.atoms.indexOf(node)) && !rejectedBondsString.has(container.atoms.indexOf(node)+"-"+container.atoms.indexOf(node))) {
                    rejectedBonds.add([node,child]);
                    rejectedBondsString.add(container.atoms.indexOf(node)+"-"+container.atoms.indexOf(child));
                }
            }
        });
    });

    return rejectedBonds;
}

export const findRing = (start: IAtomModel, end: IAtomModel, spanningTree: Map<IAtomModel, Set<IAtomModel>>, visited = new Set(),
                      parents: Map<IAtomModel, IAtomModel | undefined> = new Map(), current_node = start, parent_node: IAtomModel | undefined = undefined): IAtomModel[] | undefined => {
    let ring: IAtomModel[] | undefined = undefined;
    visited.add(current_node);
    parents.set(current_node, parent_node);
    // current_node.parent = parent_node;
    // @ts-ignore
    const destinations = Array.from(spanningTree.get(current_node));
    for(const destination of destinations) {
        if( destination === end) {
            ring = getRingPath(start, end, current_node, parents);
            return ring;
        }
        if(destination === parents.get(current_node)) {
            // do nothing
            continue;
        }
        if (!visited.has(destination)) {
            ring = findRing(start, end, spanningTree, visited, parents, destination, current_node);
            if(ring != undefined) {
                return ring;
            }
        }
    }

    return ring;
}

export const getRingPath = (start: IAtomModel, end: IAtomModel, current_node: IAtomModel, parents: Map<IAtomModel, IAtomModel | undefined>) => {
    // end.isInRing = true;
    const ring = [end];
    let failed = false;
    while(current_node != start) {
        // current_node.isInRing = true;
        ring.push(current_node);
        const parent = parents.get(current_node);
        if(parent === undefined) {
            failed = true;
            break;
        }
        else current_node = parent;
    }
    if(failed) return [];

    // start.isInRing = true;
    ring.push(start);
    return ring;
}

export const removeOverlapRings = (container: AtomContainer, rings: IAtomModel[][]) => {
    rings.forEach((ring,i1) => {
        rings.forEach((ring2, i2) =>{
            if(i1 < i2) { // check for overlap
                let biggerOne = ring;
                let smallerOne = ring2;
                if(ring2.length > ring.length){
                    biggerOne = ring2;
                    smallerOne = ring;
                }
                let subset = true;
                for(const a of smallerOne) {
                    if(!biggerOne.includes(a)) {
                        subset = false;
                        break;
                    }
                }

                if(subset) {

                    const overlapAtoms: IAtomModel[] = []
                    smallerOne.forEach(a => {
                        // const nonOverLapBonds = container.getBondsAttachedTo(a).filter(b => (b.a1 === a as AtomModel && !smallerOne.includes(b.a2 as AtomModel) ||
                        //     (b.a2 === a && !smallerOne.includes(b.a1 as AtomModel))));
                        const nonOverLapBonds: IBondModel[] = [];
                        container.getBondsAttachedTo(a).forEach(b => {
                            if(b.a1 === a && !smallerOne.includes(b.a2) && biggerOne.includes(b.a2)) {
                                nonOverLapBonds.push(b);
                            }
                            else if (b.a2 === a && !smallerOne.includes(b.a1) && biggerOne.includes(b.a1)) {
                                nonOverLapBonds.push(b);
                            }
                        })
                        if(nonOverLapBonds.length > 0) {
                            // overlap atoms
                            overlapAtoms.push(a);
                        }
                    })

                    smallerOne.forEach(a => {
                        if(!overlapAtoms.includes(a)) biggerOne.splice(biggerOne.indexOf(a),1)
                    })
                }
            }
        })
    })
}